import React, { useState, createContext } from 'react'

export const ColorContext = createContext();

export const ColorProvider = ({ children }) => {
    const [selectedColor, setSelectedColor] = useState('#111827');
    const [multiColoring, setMultiColoring] = useState(false);
    const [isMouseDown, setIsMouseDown] = useState(false);
    const [nodeList, setNodeList] = useState([]);


    return (
        <ColorContext.Provider value={{ selectedColor, setSelectedColor , isMouseDown, setIsMouseDown, multiColoring, setMultiColoring, nodeList, setNodeList }}>
            {children}
        </ColorContext.Provider>
    );
}
